import useIsMobileSize from 'src/hooks/useIsMobileSize';
import { DesktopLayout, WithoutHeader } from 'src/layout';
import { Box } from '@mui/material';

import DescribeYourBusiness from 'src/screens/DescribeYourBusiness/Content';

export default function ProfileScreen() {
    const isMobile = useIsMobileSize();

    if (isMobile) {
        return (
            <WithoutHeader showBack>
                <DescribeYourBusiness />
            </WithoutHeader>
        );
    }

    return (
        <DesktopLayout hideRightSidebar>
            <Box sx={{ maxWidth: 800 }}>
                <DescribeYourBusiness />
            </Box>
        </DesktopLayout>
    );
}
